module.exports = __webpack_public_path__ + "img/locker-room-gal-2.3d4ac860.jpg";